// Import our CSS
import '../less/main.css';

import $ from "jquery";
window.jQuery = $;
import "./components/cookiebot";
import initCookiebotBlocked from "./components/cookiebotBlocked";
import "./components/utm_forwarder";

initCookiebotBlocked();

import CustomNavigation from "./components/customNavigation";

$(function () {
    CustomNavigation.init();
});

// Add JS Loaded class to the body
document.documentElement.classList.add('js-loaded');

// WF-2059: Slick clones slides with jQuery clone(true). The clone gets the class lazyloading,
// but not the load listener of lazysizes. Without this the clone stays at opacity 0.
['load', 'error'].forEach((type) => document.addEventListener(type, (event) => {
    const img = event.target;
    if (img instanceof HTMLImageElement && img.classList.contains('lazyloading') && img.closest('.slick-cloned')) {
        img.classList.replace('lazyloading', 'lazyloaded');
    }
}, true));

// App main
const main = async () => {
    // WF-2059: start lazysizes first. Each lazy image shows no picture until lazysizes runs.
    // Before, lazysizes waited for the whole _scripts chain, also above the fold.
    const lazyloading = import("./components/lazyloading");

    // Import Scripts
    await import('./_scripts');

    await Promise.all([
        import('./scripts/calendly'),
        import("./components/fix_nav_scrolling"),
        import("./components/scroll_to_top"),
        lazyloading,
        import("./components/navigationScroll"),
    ]);

    // Import Components
    //await import('./_vue-components');
    if (document.getElementById("app_vorteilsrechner")) {
        await import('../vue/main.js');
    }

    if (document.getElementById("signup-page")) {
        await Promise.all([
            import("./components/coupon"),
            import("./initSignup"),
        ]);
    }
};

// Execute async function
// eslint-disable-next-line
main()
// eslint-disable-next-line @typescript-eslint/no-empty-function
    .then(() => {

    })
    .catch((e) => console.error(e));
